import { z } from "zod";

export const OnboardingWelcomeItemSchema = z.object({
  Completed: z.boolean().optional(),
});

export type OnboardingWelcomeItemType = z.infer<
  typeof OnboardingWelcomeItemSchema
>;
